<template>
    <div class="flex h-16 w-16 items-center justify-center rounded-full bg-ds-gray-200 p-3 text-semantic-primary-default">
        <DsIcon
            icon="fa-regular fa-image"
            size="xl"
        />
    </div>

    <slot name="dropzoneText">
        <div class="text-center text-content-lg font-medium text-content-primary">
            {{ text }}
        </div>
    </slot>
</template>

<script setup lang="ts">
import DsIcon from '@ds/DsIcon.vue';

defineProps<{
    text: string;
}>();

defineSlots<{
    dropzoneText: () => void;
}>();
</script>
